const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_khDfeGtnf",
  "aws_user_pools_web_client_id": "57fs8b4012cflttabjdfiqm1dt",
  "oauth": {},
  "aws_cognito_username_attributes": ["EMAIL"],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": ["EMAIL"],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": ["SMS"],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": ["EMAIL"],
  "API": {
    "endpoints": [
      {
        "name": "TitleManagerAPI",
        "endpoint": "https://api.title-manager.rduboue.people.aws.dev/",
        "region": "us-east-1"
      }
    ]
  }
};

export default awsmobile;
